var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map_content",
    "data-name": "map content",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.412,
    height: 50,
    viewBox: "0 0 62.412 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M35.165-26h-16c-4.418,0-9.558,2.283-11.48,5.1L.726-10.7c-1.922,2.817.1,5.1,4.52,5.1h16l4.52,5.1L39.685-20.9C41.607-23.717,39.583-26,35.165-26Z",
    transform: "translate(0 26)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M200,286H176a12.035,12.035,0,0,0-12,12h0v24a12.035,12.035,0,0,0,12,12h24l12,10V298A12.035,12.035,0,0,0,200,286Z",
    transform: "translate(-164 -286)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pins",
    transform: "translate(40 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(-0.389)",
    fill: "#46db96"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow",
    transform: "translate(22 32)",
    opacity: 0.23,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 44,
    height: 28,
    transform: "translate(-3.389 2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mark-2",
    "data-name": "mark",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_147",
    "data-name": "Trac\\xE9 147",
    d: "M0,0H53V66H0Z",
    transform: "translate(-2 -3)",
    fill: "#dba246"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-map-pin",
    "data-name": "Icon feather-map-pin",
    transform: "translate(15.426 14.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_114",
    "data-name": "Trac\\xE9 114",
    d: "M21.729,10.114c0,6.7-8.614,12.443-8.614,12.443S4.5,16.814,4.5,10.114a8.614,8.614,0,1,1,17.229,0Z",
    transform: "translate(-4.5 -1.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_115",
    "data-name": "Trac\\xE9 115",
    d: "M19.243,13.371A2.871,2.871,0,1,1,16.371,10.5a2.871,2.871,0,0,1,2.871,2.871Z",
    transform: "translate(-7.757 -4.757)",
    fill: "#46a7db"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerIcon);
export default __webpack_public_path__ + "static/media/markerIcon.bbccc9aad1431aedbfc312b4908a72c3.svg";
export { ForwardRef as ReactComponent };